// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__34taH","container":"styles_container__3-wVj","title":"styles_title__FBlty","wrapper":"styles_wrapper__2ifKz","answer":"styles_answer__7ig-W"};